import React, { createContext, useContext, useState } from 'react';

interface ClientInfo {
  voice: string;
  trn: string;
  name: string;
  dateofbirth: string;
  debtamount: number;
  currency: string;
  origin: string;
  IBAN: string;
  maxDiscount: number;
}

interface HVAConversationContextType {
  clientInfo: ClientInfo | null;
  setClientInfo: (info: ClientInfo) => void;
  isNifValidated: boolean;
  setIsNifValidated: (validated: boolean) => void;
  isDobValidated: boolean;
  setIsDobValidated: (validated: boolean) => void;
  requestTransfer: boolean;
  setRequestTransfer: (transfer: boolean) => void;
}

const HVAConversationContext = createContext<
  HVAConversationContextType | undefined
>(undefined);

export const HVAConversationProvider: React.FC<{
  children: React.ReactNode;
}> = ({ children }) => {
  const [clientInfo, setClientInfo] = useState<ClientInfo | null>(null);
  const [isNifValidated, setIsNifValidated] = useState(false);
  const [isDobValidated, setIsDobValidated] = useState(false);
  const [requestTransfer, setRequestTransfer] = useState(false);

  const value = {
    clientInfo,
    setClientInfo,
    isNifValidated,
    setIsNifValidated,
    isDobValidated,
    setIsDobValidated,
    requestTransfer,
    setRequestTransfer
  };

  return (
    <HVAConversationContext.Provider value={value}>
      {children}
    </HVAConversationContext.Provider>
  );
};

export const useHVAConversation = () => {
  const context = useContext(HVAConversationContext);
  if (context === undefined) {
    throw new Error(
      'useHVAConversation must be used within a HVAConversationProvider'
    );
  }
  return context;
};
